export default "__VITE_ASSET__cb85e58c__"